//判断是否为空,v为传入的值
export function isEmpty(v) {
    switch (typeof v) {
        case 'undefined':
            return true
        case 'string':
            if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true
            break
        case 'boolean':
            if (!v) return true
            break
        case 'number':
            if (0 === v || isNaN(v)) return true
            break
        case 'object':
            if (null === v || v.length === 0) return true
            for (var i in v) {
                return false
            }
            return true
    }
    return false
}
// JS判断几位小数，只保留几位小数
export function toFixedDot(totle, manyDot = 2, howDot = 2) {
    var dot = String(totle).indexOf(".");
    if (dot != -1) {
        var dotCnt = String(totle).substring(dot + 1, totle.length);
        if (dotCnt.length > manyDot) {
            totle = Number(totle).toFixed(howDot);
        }
    }
    return Number(totle);
}
export const timezoneParse = (time) => {
    time = typeof time === 'string' ? time.replace(/-/g, '/') : time
    let nowSystemTimezoneOffset = -480 * 60 * 1000;
    let userTimeZoneOffset = new Date().getTimezoneOffset();
    let divTimeZone = nowSystemTimezoneOffset - (userTimeZoneOffset * 60 * 1000);
    let clientTime = new Date(time).getTime() + divTimeZone;
    return `${formateTime(clientTime)} (UTC${getUserTimezone()})`;
}
export const formateTime = (val, length) => {
    if (!val) return;
    if (String(val).length < 13) {
        val = val * 1000;
    }
    let time = new Date(val);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    let h = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
    let mm = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
    let s = time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();
    if (length) return h + ':' + mm + ':' + s;
    return y + '/' + m + '/' + d + ' ' + h + ':' + mm + ':' + s;
}